import React, { Component } from 'react'
import {path} from './Constant';
export default class Arrival extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
        }
    }
    render() {
        return (
            <div id="your-arrival">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h2>{this.props.static_text.your_arrival_text}</h2>
                                                <div className="row my-3">
                                                    <div className="col-md-2">
                                                        <img src={path+"images/icon12.jpg"} className="img-fluid d-block" alt="Airport" />
                                                    </div>
                                                    <div className="col-md-10">
                                                        <p> {this.props.data.airport_text}</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <img src={path+"images/icon13.jpg"} className="img-fluid d-block" alt="Ferry pier" />
                                                    </div>
                                                    <div className="col-md-10">
                                                        <p> {this.props.data.pier_text} </p>
                                                    </div>
                                                </div>
                                                <div className="row my-3">
                                                    <div className="col-md-2">
                                                        <img src={path+"images/icon14.jpg"} className="img-fluid d-block" alt="GPS" />
                                                    </div>
                                                    <div className="col-md-10">
                                                        <p>{this.props.data.car_rental_text}</p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <img src={path+"images/icon15.jpg"} className="img-fluid d-block" alt="GPS location" />
                                                    </div>
                                                    <div className="col-md-10">
                                                      <p>{this.props.data.other_text}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-12">
                                                        <h6>{this.props.static_text.check_in_text}</h6>
                                                        <p>{this.props.data.check_in_text}</p> 
                                                    </div>
                                                    <div className="col-md-12">
                                                        <h6>{this.props.static_text.before_and_during_text}</h6>
                                                        <p>{this.props.data.stay_text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
        )
    }
}
